import React, { useState, useEffect } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { Alert, Pergunta } from '../../../util/Alertas'
import { GetDataUser } from '../../../util/GetDataUser'
import { api } from '../../api/api';
import { FormataData } from '../../../util/FormatacaoUtil';
import Calendar from '../../ui/Calendar';

function ModalNovoPedido({
    CalcularValorMinimo = () => { },
    modalAberto = true,
    setModal = () => { },
    clienteSelecionado = {},
    produtos = [],
    setProdutoSelecionado = () => { },
    quantidade = 0,
    handleQuantidadeChange = () => { },
    produtoSelecionado = {},
    adicionarProduto = () => { },
    produtosAdicionados = [],
    handleDescontoReaisChange = () => { },
    removerProduto = () => { },
    descontoPercentual = 0,
    handleDescontoPercentualChange = () => { },
    calcularValorTotalPedido = () => { },
    observacao = "",
    setObservacao = () => { },
    handleEnviarPedido = () => { },
    mensagem = "",
    closeModalNovoPedido = () => { },
    vendedorComissao,
    prazoPgt = '',
    setPrazoPgt = () => { },
    formaPgt = '',
    setFormaPgt = () => { },
    pedidoEmiteNf = '',
    setPedidoEmiteNf = () => { },
    dataVencimentoPgt = '',
    setDataVencimentoPgt = () => { },
    dataEstimadaEntrega = '',
    setDataEstimadaEntrega = () => { },
    usuarios = [],
    vendedorSelecionado,
    setVendedorSelecionado
}) {
    const [showUltimoPedido, setShowUltimoPedido] = useState(false);
    const [ultimoPedido, setUltimoPedido] = useState(null)
    const usuario = GetDataUser();
    const getValue = () => produtoSelecionado && (quantidade * produtoSelecionado.valor).toFixed(2);

    const onChangeProdutoSelecionado = (e) => {
        const produtoId = parseInt(e.target.value);
        const produtoSelecionado = produtos.find(
            (p) => p.id === produtoId
        );
        setProdutoSelecionado(produtoSelecionado);
    }

    const isDate = (value) => {
        return value instanceof Date && !isNaN(value.getTime());
    };
    
    const onChageDias = ({ target }) => {
        const { value } = target;
        const dias = parseInt(value, 10);
        if (!isNaN(dias)) {
            const novaData =
                !dataEstimadaEntrega
                    ? new Date()
                    : isDate(dataEstimadaEntrega)
                        ? dataEstimadaEntrega
                        : new Date(`${dataEstimadaEntrega}T00:00:00`);
            novaData.setDate(novaData.getDate() + dias);
            setDataVencimentoPgt(novaData.toISOString().split('T')[0]);

            const dataEstimadaNova = novaData;
            dataEstimadaNova.setDate(novaData.getDate() - dias);
            setDataEstimadaEntrega(dataEstimadaNova.toISOString().split('T')[0]);
        }
        setPrazoPgt(value);
    }

    const onChangeVencimento = ({ target }) => {
        const { value } = target;

        const hoje = new Date
        hoje.setHours(0, 0, 0, 0);

        const dataSelecionada = new Date(`${value}T00:00:00`);
        dataSelecionada.setHours(0, 0, 0, 0);

        if (dataSelecionada < hoje) {
            Alert("A data de vencimento não pode ser menor que hoje.", true, true);
            target.value = "";
            return;
        }

        const diffEmMilissegundos = dataSelecionada - hoje;
        const diffEmDias = Math.ceil(diffEmMilissegundos / (1000 * 60 * 60 * 24));
        setPrazoPgt(diffEmDias);
        setDataVencimentoPgt(value);
    };

    const onChangeVencimentoByData = ({ target }) => {
        const { value } = target;

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        const dataSelecionada = new Date(`${value}T00:00:00`);
        dataSelecionada.setHours(0, 0, 0, 0);

        if (dataSelecionada < hoje) {
            Alert("A data estimada de entrega não pode ser menor que hoje.", true, true);
            target.value = "";
            return;
        }

        const dataVencimento = new Date(dataSelecionada);
        dataVencimento.setDate(dataVencimento.getDate() + Number(prazoPgt));
        const vencimentoFormatado = dataVencimento.toISOString().split("T")[0];
        setDataVencimentoPgt(vencimentoFormatado);
    };

    const buscarUltimoPedido = () => {
        api.get('/api/Pedido/UltimoPedido/' + clienteSelecionado.id, async res => {
            setUltimoPedido(res.data);
            if ((await Pergunta('Deseja preencher os dados complementares de acordo com o ultimo pedido?'))) {
                const Pedido = res.data;

                setObservacao(Pedido.observacao);
                setPrazoPgt(Pedido.prazo_pagamento);
                setFormaPgt(Pedido.forma_pagamento);
                setPedidoEmiteNf(Pedido.emite_nota_fiscal ? "Sim" : "Não");

                const novaData = new Date();
                setDataEstimadaEntrega(novaData)
                const dias = parseInt(Pedido.prazo_pagamento);
                if (!isNaN(dias)) {
                    novaData.setDate(novaData.getDate() + dias);
                    setDataVencimentoPgt(novaData.toISOString().split('T')[0]);
                }
            } else {
                const novaData = new Date();
                const dias = parseInt(clienteSelecionado.prazo_pagamento);
                setPrazoPgt(clienteSelecionado.prazo_pagamento);
                novaData.setDate(novaData.getDate() + dias);
                setDataVencimentoPgt(novaData.toISOString().split('T')[0]);
            }
        })
    }

    useEffect(() => {
        if (clienteSelecionado && clienteSelecionado.id) {
            buscarUltimoPedido();
        }
    }, [clienteSelecionado])

    useEffect(() => {
        if (!modalAberto)
            setShowUltimoPedido(false);
    }, [modalAberto])

    return (
        <Modal
            size='xl'
            show={modalAberto}
        >
            <Modal.Header>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: "100%" }}>
                    <h2>
                        {clienteSelecionado
                            ? clienteSelecionado.nome
                            : "Selecione um cliente"}
                    </h2>
                    <button onClick={() => setShowUltimoPedido(!showUltimoPedido)} className='btn btn-primary'>{showUltimoPedido ? 'Ocultar' : 'Ver'} Ultimo Pedido</button>
                </div>
            </Modal.Header>
            {showUltimoPedido && <Modal.Body>
                {!ultimoPedido && "Não há registro de último pedido realizado pelo cliente."}
                {ultimoPedido && <>
                    <h3 style={{ color: 'gray' }}>Ultimo Pedido: <b style={{ color: 'black' }}>#{ultimoPedido.pedido_id} / {FormataData(ultimoPedido.data_pedido)}</b></h3>
                    <h3 style={{ color: 'gray' }}>Prazo - Pgto - NF: <b style={{ color: 'black' }}>{ultimoPedido.prazo_pagamento} dias / {ultimoPedido.forma_pagamento} / NF {ultimoPedido.emite_nota_fiscal ? 'Sim' : 'Não'}</b></h3>
                    <h3 style={{ color: 'gray' }}>Total: <b style={{ color: 'black' }}>R$ {ultimoPedido.valor_total.toFixed(2)}</b></h3>

                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th>Produto</th>
                                <th>Quantidade</th>
                                <th>Vlr.Unit.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ultimoPedido.produtos.map(produto => {
                                var produtoAtual = produtos.find(x => x.id == produto.produto_id);
                                if (produtoAtual) {
                                    return (<tr>
                                        <td>{produtoAtual.nome}</td>
                                        <td>{produto.quantidade}</td>
                                        <td>R$ {(produto.valor_unitario - (produto.desconto_unitario / produto.quantidade)).toFixed(2)}</td>
                                    </tr>)
                                }
                            })}
                        </tbody>
                    </table>

                </>}
            </Modal.Body>}
            {!showUltimoPedido && <Modal.Body>
                <div className='row'></div>
                <div className="container">
                    {usuario.IsMaster && <Row>
                        <Col md={6}>
                            <label>Vendedor</label>
                            <select
                                id="produtos"
                                className="form-control"
                                value={vendedorSelecionado}
                                onChange={e => setVendedorSelecionado(e.target.value)}
                            >
                                <option value={usuario.UsuarioId}>Usuário Atual</option>
                                {usuarios.map((usuario) => (
                                    <option
                                        key={usuario.usuarioId}
                                        value={usuario.usuarioId}
                                    >
                                        {usuario.nome}
                                    </option>
                                ))}
                            </select>
                        </Col>
                    </Row>}
                    <Row>
                        <Col md={6}>
                            <label>Produto</label>
                            <select
                                id="produtos"
                                className="form-control"
                                onChange={onChangeProdutoSelecionado}
                            >
                                <option value="">Selecione um Produto</option>
                                {produtos.map((produto) => (
                                    <option
                                        key={produto.id}
                                        value={produto.id}
                                    >
                                        {produto.nome}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col md={6}>
                            <label>Quantidade</label>
                            <input
                                className='form-control'
                                type="number"
                                min="1"
                                value={quantidade}
                                onChange={handleQuantidadeChange}
                                contentLabel="Quantidade"
                            />
                        </Col>
                        <Col md={10}>
                            <label htmlFor="">Total</label>
                            <input
                                className='form-control'
                                disabled
                                type="text"
                                value={`R$ ${getValue() ? getValue() : 0}`}
                                onChange={handleQuantidadeChange}
                            />
                        </Col>
                        <Col md={2}>
                            <label htmlFor=""></label>
                            <button
                                style={{ marginTop: '2rem', width: '100%' }}
                                className="btn btn-success"
                                onClick={() => adicionarProduto()}
                            ><FaPlus /></button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={12}>
                            <table className='table table-striped'>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Quantidade</th>
                                        <th>Valor Desconto</th>
                                        <th>Valor Total</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {produtosAdicionados.map((produto, index) => {
                                        return (
                                            <tr key={index}>
                                                <td data-label="Nome">{produto.nome}</td>
                                                <td data-label="Quantidade">{produto.quantidade}</td>
                                                <td data-label="Valor Desconto">
                                                    <input
                                                        type="text"
                                                        style={{ width: '50%' }}
                                                        value={produto.valorDesconto === 0 ? '' : produto.valorDesconto} // Isso permite que o campo seja apagado
                                                        onChange={(e) => handleDescontoReaisChange(produto.id, produto.quantidade, e)}
                                                        step="0.01"
                                                        min={0}
                                                    />

                                                </td>
                                                <td data-label="Valor Total">
                                                    R${" "}
                                                    {(
                                                        produto.valor * produto.quantidade -
                                                        (produto.valorDesconto || 0)
                                                    ).toFixed(2)}
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => removerProduto(produto)}
                                                        className='btn btn-danger'
                                                    >
                                                        -
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row>
                        {produtosAdicionados.length > 0
                            && <Col md={12}>
                                <label>Desconto em %:</label>
                                <input
                                    className='form-control'
                                    type="text"
                                    value={descontoPercentual}
                                    onChange={e => { handleDescontoPercentualChange(e); CalcularValorMinimo(e.target.value) }}
                                    pattern="\d*\.?\d*"
                                    title="Insira um número decimal válido"
                                />
                            </Col>}
                        {produtosAdicionados.length > 0
                            && <Col md={6} style={{ width: '100%', textAlign: 'end', marginTop: 10 }}>
                                <label style={{ fontSize: 25 }}>Total: R$ {calcularValorTotalPedido()}</label>
                            </Col>}
                        {produtosAdicionados.length > 0
                            && <Col md={6} style={{ width: '100%', textAlign: 'end', marginTop: 10 }}>
                                <small>Valor Comissão: R$ {((calcularValorTotalPedido() * vendedorComissao) / 100).toFixed(2)}</small>
                            </Col>}
                    </Row>
                    <br />
                    <Row>
                        {produtosAdicionados.length > 0
                            && <Col md={6}>
                                <label>Prazo para pagamento(Em Dias)</label>
                                <input value={prazoPgt} onChange={onChageDias} min={1} max={365} className='form-control' placeholder='Em Dias' type="number" name="" id="" />
                            </Col>}
                        {produtosAdicionados.length > 0
                            && <Col md={6}>
                                <label>Prazo para pagamento(Vencimento)</label>
                                <input value={dataVencimentoPgt} onChange={onChangeVencimento} className='form-control' type="date" name="" id="" />
                            </Col>}
                        <br />
                        <br />
                        {produtosAdicionados.length > 0
                            && <Col md={6}>
                                <label>Forma de pagamento</label>
                                <select value={formaPgt} onChange={e => setFormaPgt(e.target.value)} className='form-control' name="" id="">
                                    <option value="Dinheiro">Dinheiro</option>
                                    <option value="Cartão">Cartão</option>
                                    <option value="Pix">Pix</option>
                                    <option value="Boleto">Boleto</option>
                                </select>
                            </Col>}
                        {produtosAdicionados.length > 0
                            && <Col md={6}>
                                <label>Pedido emite nota fiscal?</label>
                                <select value={pedidoEmiteNf} onChange={e => setPedidoEmiteNf(e.target.value)} className='form-control' name="" id="">
                                    <option value="Sim">Sim</option>
                                    <option value="Não">Não</option>
                                </select>
                            </Col>}
                        {produtosAdicionados.length > 0
                            && <Col md={6}>
                                <label>Data Estimada Entrega</label>
                                <Calendar
                                    selectedDate={dataEstimadaEntrega}
                                    setSelectedDate={setDataEstimadaEntrega}
                                    allowedDays={clienteSelecionado.dias ?? []}
                                    disablePastDates
                                />
                                {/* <input value={dataEstimadaEntrega} onChange={e => { setDataEstimadaEntrega(e.target.value); onChangeVencimentoByData(e) }} type="date" className='form-control' /> */}
                            </Col>}
                    </Row>
                    <br />
                    <br />
                    <Row>
                        {produtosAdicionados.length > 0
                            && <Col md={12}>
                                <label>Observação:</label>
                                <textarea
                                    className="form-control"
                                    value={observacao}
                                    onChange={(e) => setObservacao(e.target.value)}
                                    placeholder="Digite alguma observação sobre o pedido aqui."
                                ></textarea>
                            </Col>}
                    </Row>
                </div>
            </Modal.Body>}
            <Modal.Footer>
                <button className='btn btn-danger' onClick={() => closeModalNovoPedido()}>Cancelar</button>
                {produtosAdicionados.length > 0 && <button className='btn btn-primary' onClick={handleEnviarPedido}>Enviar Pedido</button>}
            </Modal.Footer>
        </Modal >
    );
}

export default ModalNovoPedido;